import React, { useState, useEffect } from 'react';
import { API_BASE } from '../../App';

const AdminCountPeriod = ({ token }) => {
  const [countPeriod, setCountPeriod] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    start_date: '',
    end_date: ''
  });
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchCountPeriod();
  }, []);

  const fetchCountPeriod = async () => {
    try {
      const response = await fetch(`/detsa/admin/count-period`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        const period = Array.isArray(data) ? data[0] : data;
        if (period) {
          period.title = period.title || period.name;
        }
        setCountPeriod(period);
      }
    } catch (error) {
      console.error('Sayım periyodu yüklenirken hata:', error);
    }
    setLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const startDate = new Date(formData.start_date);
    const endDate = new Date(formData.end_date);
    
    if (startDate >= endDate) {
      setMessage('Bitiş tarihi başlangıç tarihinden sonra olmalıdır!');
      return;
    }

    try {
      const url = countPeriod ? 
        `/detsa/admin/count-period/${countPeriod.id}` : 
        `/detsa/admin/count-period`;
      
      const method = countPeriod ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(`Sayım periyodu başarıyla ${countPeriod ? 'güncellendi' : 'oluşturuldu'}!`);
        setFormData({ title: '', description: '', start_date: '', end_date: '' });
        setShowForm(false);
        fetchCountPeriod();
        setTimeout(() => setMessage(''), 3000);
      } else {
        setMessage(data.error || 'Hata oluştu');
      }
    } catch (error) {
      setMessage('Bağlantı hatası');
    }
  };

  const handleDeleteClick = () => {
    setShowDeleteDialog(true);
  };

  const handleConfirmDelete = async () => {
    try {
      const response = await fetch(`/detsa/admin/count-period/${countPeriod.id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response.ok) {
        setMessage('Sayım periyodu başarıyla silindi!');
        setCountPeriod(null);
        setShowDeleteDialog(false);
        setTimeout(() => setMessage(''), 3000);
      } else {
        setMessage('Silme işleminde hata oluştu!');
        setShowDeleteDialog(false);
      }
    } catch (error) {
      setMessage('Bağlantı hatası!');
      setShowDeleteDialog(false);
    }
  };

  const handleCancelDelete = () => {
    setShowDeleteDialog(false);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('tr-TR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const isActive = () => {
    if (!countPeriod) return false;
    const now = new Date();
    const start = new Date(countPeriod.start_date);
    const end = new Date(countPeriod.end_date);
    return now >= start && now <= end;
  };

  if (loading) {
    return <div className="loading">Yükleniyor...</div>;
  }

  return (
    <div className="admin-count-period">
      <div className="count-period-header">
        <h3>Sayım Periyodu Yönetimi</h3>
        {!countPeriod && (
          <button 
            onClick={() => setShowForm(!showForm)}
            className="btn-primary"
          >
            + Sayım Periyodu Oluştur
          </button>
        )}
      </div>

      {countPeriod && (
        <div className={`current-period ${isActive() ? 'active' : 'inactive'}`}>
          <h4>{countPeriod.title}</h4>
          <div className="period-details">
            <p><strong>Başlangıç:</strong> {formatDate(countPeriod.start_date)}</p>
            <p><strong>Bitiş:</strong> {formatDate(countPeriod.end_date)}</p>
            {countPeriod.description && (
              <p><strong>Açıklama:</strong> {countPeriod.description}</p>
            )}
            <p><strong>Durum:</strong> 
              <span className={`status ${isActive() ? 'active' : 'inactive'}`}>
                {isActive() ? ' 🟢 Aktif' : ' 🔴 Pasif'}
              </span>
            </p>
            <p><strong>Oluşturulma:</strong> {formatDate(countPeriod.created_at)}</p>
          </div>
          <div className="period-actions">
            <button 
              onClick={() => {
                setFormData({
                  title: countPeriod.title || countPeriod.name || '',
                  description: countPeriod.description || '',
                  start_date: countPeriod.start_date ? countPeriod.start_date.split('T')[0] : '',
                  end_date: countPeriod.end_date ? countPeriod.end_date.split('T')[0] : ''
                });
                setShowForm(true);
              }}
              className="btn-secondary"
            >
              Düzenle
            </button>
            <button 
              onClick={handleDeleteClick}
              className="btn-danger"
            >
              Sil
            </button>
          </div>
        </div>
      )}

      {showForm && (
        <div className="count-period-form">
          <h4>{countPeriod ? 'Sayım Periyodunu Düzenle' : 'Yeni Sayım Periyodu'}</h4>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Sayım Başlığı *:</label>
              <input
                type="text"
                value={formData.title}
                onChange={(e) => setFormData({...formData, title: e.target.value})}
                required
                placeholder="Örn: 2025 Yıl Sonu Sayımı"
              />
            </div>
            
            <div className="form-row">
              <div className="form-group">
                <label>Başlangıç Tarihi *:</label>
                <input
                  type="date"
                  value={formData.start_date}
                  onChange={(e) => setFormData({...formData, start_date: e.target.value})}
                  required
                />
              </div>
              <div className="form-group">
                <label>Bitiş Tarihi *:</label>
                <input
                  type="date"
                  value={formData.end_date}
                  onChange={(e) => setFormData({...formData, end_date: e.target.value})}
                  required
                />
              </div>
            </div>
            
            <div className="form-group">
              <label>Açıklama:</label>
              <textarea
                value={formData.description}
                onChange={(e) => setFormData({...formData, description: e.target.value})}
                rows="3"
                placeholder="Sayım hakkında ek bilgiler..."
              />
            </div>
            
            <div className="form-actions">
              <button type="submit" className="btn-primary">
                {countPeriod ? 'Güncelle' : 'Oluştur'}
              </button>
              <button 
                type="button" 
                onClick={() => setShowForm(false)}
                className="btn-secondary"
              >
                İptal
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Delete Confirmation Dialog */}
      {showDeleteDialog && (
        <div className="dialog-overlay">
          <div className="dialog-container delete-dialog">
            <div className="dialog-header">
              <h4>⚠️ Sayım Periyodunu Sil</h4>
              <button 
                className="dialog-close" 
                onClick={handleCancelDelete}
              >
                ✕
              </button>
            </div>
            
            <div className="dialog-content">
              <div className="warning-section">
                <div className="warning-icon">🗑️</div>
                <div className="warning-text">
                  <p><strong>Bu işlem geri alınamaz!</strong></p>
                  <p>
                    "<strong>{countPeriod?.title}</strong>" sayım periyodunu silmek istediğinizden emin misiniz?
                  </p>
                </div>
              </div>
              
              <div className="period-summary">
                <h5>Silinecek Periyod Bilgileri:</h5>
                <ul>
                  <li><strong>Başlık:</strong> {countPeriod?.title}</li>
                  <li><strong>Tarih Aralığı:</strong> {formatDate(countPeriod?.start_date)} - {formatDate(countPeriod?.end_date)}</li>
                  <li><strong>Durum:</strong> {isActive() ? 'Aktif' : 'Pasif'}</li>
                  {countPeriod?.description && (
                    <li><strong>Açıklama:</strong> {countPeriod.description}</li>
                  )}
                </ul>
              </div>
            </div>
            
            <div className="dialog-actions">
              <button 
                className="btn-secondary" 
                onClick={handleCancelDelete}
              >
                İptal
              </button>
              <button 
                className="btn-danger" 
                onClick={handleConfirmDelete}
              >
                🗑️ Sil
              </button>
            </div>
          </div>
        </div>
      )}

      {message && (
        <div className={`message ${message.includes('başarı') ? 'success' : 'error'}`}>
          {message}
        </div>
      )}
    </div>
  );
};

export default AdminCountPeriod;